var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterLinkdinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 6.66699C14.6591 6.66699 15.9309 7.19378 16.8685 8.13146C17.8062 9.06914 18.333 10.3409 18.333 11.667V17.5003H14.9997V11.667C14.9997 11.225 14.8241 10.801 14.5115 10.4885C14.199 10.1759 13.775 10.0003 13.333 10.0003C12.891 10.0003 12.4671 10.1759 12.1545 10.4885C11.8419 10.801 11.6663 11.225 11.6663 11.667V17.5003H8.33301V11.667C8.33301 10.3409 8.85979 9.06914 9.79747 8.13146C10.7352 7.19378 12.0069 6.66699 13.333 6.66699Z",
    stroke: "#99A1AF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00033 7.5H1.66699V17.5H5.00033V7.5Z",
    stroke: "#99A1AF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33366 5.00033C4.25413 5.00033 5.00033 4.25413 5.00033 3.33366C5.00033 2.41318 4.25413 1.66699 3.33366 1.66699C2.41318 1.66699 1.66699 2.41318 1.66699 3.33366C1.66699 4.25413 2.41318 5.00033 3.33366 5.00033Z",
    stroke: "#99A1AF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLinkdinIcon);
export default __webpack_public_path__ + "static/media/footer-linkdin-icon.9c4024cb0c31f462112c4fbb7cd96e6d.svg";
export { ForwardRef as ReactComponent };